import React, { useEffect, useRef, useState } from 'react'
import AllProductsStyle from '../AllProducts/AllProducts'
import Button from '../../components/Button'
import Layout from '../../components/Layout'
import { ErrorModal } from '../../components/Modal'
import ClipLoader from 'react-spinners/ClipLoader'
import { cashbackApi } from '../../api'
import { get } from 'lodash'
import { isAxiosError } from 'axios'
import moment from 'moment'
import dayjs from 'dayjs'
import { DatePicker, Empty } from 'antd'
import { BG_COLOR } from '../../constants/colors'

const { RangePicker } = DatePicker
const dateFormat = 'YYYY-MM-DD'

const Complaints = () => {
	const errorRef = useRef()

	const [isLoading, setIsLoading] = useState(false)
	const [items, setItems] = useState([])
	const [page, setPage] = useState(1)
	const [pageSize, setPageSize] = useState(50)
	const [totalCount, setTotalCount] = useState(0)
	const [totalPages, setTotalPages] = useState(1)
	const [dateStart, setDateStart] = useState(
		moment().startOf('month').format(dateFormat),
	)
	const [dateEnd, setDateEnd] = useState(moment().format(dateFormat))

	const onRangeChange = (dates) => {
		if (dates) {
			setDateStart(dates[0].format(dateFormat))
			setDateEnd(dates[1].format(dateFormat))
		} else {
			setDateStart('')
			setDateEnd('')
		}
	}

	const getComplaints = () => {
		setIsLoading(true)
		cashbackApi
			.get('complaints', {
				params: {
					from: dateStart
						? moment(dateStart).startOf('day').toISOString()
						: undefined,
					to: dateEnd
						? moment(dateEnd).endOf('day').toISOString()
						: undefined,
					page,
					pageSize,
				},
			})
			.then((res) => {
				setItems(get(res, 'data.items', []))
				setTotalCount(get(res, 'data.totalCount', 0))
				setTotalPages(get(res, 'data.totalPages', 1))
			})
			.catch((err) => {
				if (isAxiosError(err))
					errorRef.current?.open(
						get(err, 'response.data.message', get(err, 'message', '')),
					)
			})
			.finally(() => setIsLoading(false))
	}

	useEffect(() => {
		getComplaints()
		// eslint-disable-next-line react-hooks/exhaustive-deps
	}, [page, pageSize])

	const handleSearch = () => {
		if (page === 1) getComplaints()
		else setPage(1)
	}

	return (
		<Layout>
			<AllProductsStyle
				style={{
					backgroundColor: BG_COLOR,
				}}
			>
				<div className="container">
					<p className="productTitle">Жалобы</p>
					<div className="flex items-end justify-between my-8 flex-wrap gap-4">
						<div className="flex items-end gap-4 flex-wrap">
							<div className="flex flex-col gap-1">
								<p className="text-sm font-medium">Период</p>
								<RangePicker
									value={[
										dateStart ? dayjs(dateStart, dateFormat) : null,
										dateEnd ? dayjs(dateEnd, dateFormat) : null,
									]}
									format={dateFormat}
									onChange={onRangeChange}
								/>
							</div>
							<div className="flex flex-col gap-1">
								<p className="text-sm font-medium">На странице</p>
								<select
									className="border-[1px] border-[#d9d9d9] p-2 h-10 rounded-md"
									value={pageSize}
									onChange={(e) => {
										setPageSize(Number(e.target.value))
										setPage(1)
									}}
								>
									<option value={10}>10</option>
									<option value={20}>20</option>
									<option value={50}>50</option>
									<option value={100}>100</option>
								</select>
							</div>
							<Button
								className="!h-10"
								onClick={handleSearch}
								isLoading={isLoading}
							>
								Поиск
							</Button>
						</div>
						<p className="text-sm text-gray-500">Всего: {totalCount}</p>
					</div>

					{isLoading ? (
						<ClipLoader
							loading={true}
							size={75}
							aria-label="Loading Spinner"
							className={'loader'}
							data-testid="loader"
						/>
					) : (
						<>
							<div className="overflow-x-auto mb-8">
								<table className="w-full text-sm text-left rtl:text-right text-gray-500 ">
									<thead className="text-xs text-gray-700 uppercase bg-gray-50 ">
										<tr>
											<th scope="col" className="px-6 py-4">
												Дата
											</th>
											<th scope="col" className="px-6 py-4">
												Карта
											</th>
											<th scope="col" className="px-6 py-4">
												Имя
											</th>
											<th scope="col" className="px-6 py-4">
												Телефон
											</th>
											<th scope="col" className="px-6 py-4">
												Текст
											</th>
											<th scope="col" className="px-6 py-4">
												Источник
											</th>
										</tr>
									</thead>
									<tbody>
										{items.length > 0 ? (
											items.map((v) => (
												<tr
													key={get(v, 'id')}
													className="bg-white border-b  hover:bg-gray-50 "
												>
													<td className="px-6 py-4">
														{moment(get(v, 'createdAt')).format(
															'DD-MM-YYYY HH:mm',
														)}
													</td>
													<td className="px-6 py-4">{get(v, 'cardCode', '-')}</td>
													<td className="px-6 py-4">{get(v, 'name', '-')}</td>
													<td className="px-6 py-4">{get(v, 'phone', '-')}</td>
													<td className="px-6 py-4">{get(v, 'text', '-')}</td>
													<td className="px-6 py-4">{get(v, 'source', '-')}</td>
												</tr>
											))
										) : (
											<tr>
												<td colSpan="6">
													<Empty
														description={'Ничего не найдено'}
														image={Empty.PRESENTED_IMAGE_SIMPLE}
													/>
												</td>
											</tr>
										)}
									</tbody>
								</table>
							</div>
							<div className="topCard">
								<div className="flex items-center gap-2">
									<Button
										disabled={page <= 1}
										className={'btn'}
										onClick={() => setPage((p) => p - 1)}
									>
										{'<'}
									</Button>
									<p>
										{page} / {totalPages || 1}
									</p>
									<Button
										disabled={page >= totalPages}
										className={'btn'}
										onClick={() => setPage((p) => p + 1)}
									>
										{'>'}
									</Button>
								</div>
							</div>
						</>
					)}
				</div>
			</AllProductsStyle>
			<ErrorModal
				getRef={(r) => {
					errorRef.current = r
				}}
			/>
		</Layout>
	)
}

export default Complaints
